import type { Dict } from "../core.js";
import type { cost as vi } from "../vi/cost.js";

export const cost: Dict<typeof vi> = {
  title: "Infrastructure cost",
  subtitle:
    "Neon (compute CU-hours) and GCP (money on the billing export), captured once a day. Every figure carries its source, data cut-off and quality; no source, no figure.",
  loadFailed: "Could not load cost figures.",
  generatedAt: "Computed at {time}",

  "section.sources": "Data sources",
  "section.apps": "By app",
  "section.appsHint": "Latest settled day (24 hours + source lag), this week vs last week, 30-day run-rate = 7-day average × 30.",
  "section.topDelta": "Biggest increases",
  "section.topDeltaHint": "Resources that grew most against the median of the previous 7 settled days.",
  "section.unattributed": "Not attributed to an app",
  "section.unattributedHint": "Resources with cost the hub cannot map to an app — must go to 0 or into an owned bucket.",

  "provider.neon": "Neon",
  "provider.gcp": "GCP",
  "source.neon.consumption_v2": "Neon consumption API v2 (hourly, summed per Vietnam day)",
  "source.gcp.billing_export": "BigQuery billing export (detailed table)",

  "status.ok": "Collected",
  "status.empty": "Collected · source has no rows yet",
  "status.failed": "Collection failed",
  "status.forbidden": "Access denied",
  "status.not_configured": "Not configured",
  "status.never": "The worker has not collected yet",

  "quality.measured": "measured",
  "quality.derived": "derived",
  "quality.estimated": "estimated",
  "quality.unknown": "unknown",

  "unit.cu_hours": "CU-h",

  "col.source": "Source",
  "col.status": "Status",
  "col.lastAttempt": "Last attempt",
  "col.lastSuccess": "Last success",
  "col.settled": "Latest settled day",
  "col.error": "Error code",
  "col.app": "App",
  "col.provider": "Source",
  "col.latest": "Settled day",
  "col.thisWeek": "Last 7 days",
  "col.lastWeek": "Previous 7 days",
  "col.wow": "Week over week",
  "col.runRate": "30-day run-rate",
  "col.resource": "Resource",
  "col.baseline": "7-day median",
  "col.delta": "Delta",

  "bucket.unattributed": "not attributed",
  "bucket.shared": "shared",
  emptyApps: "No settled day yet — nothing to compare.",
  emptyTopDelta: "No resource grew against its 7-day median (or fewer than 4 baseline days).",
  emptyUnattributed: "None — every cost is attributed to an app.",
  asOf: "Data up to {time}",
  noValue: "—",
};
